// @flow

import type { T_IconPair, T_User } from './types.js';
import { Unknown } from './roles.js';

export const ROOT_NAME: string = 'Carpeta raíz';

export const ROOT_DIR: string = '/MAPS';

export const DOMAIN: string = 'gdb.agrosat.cl'; // el script /GDB3/up-gdb-frontend corrige devel -> gdb.

export const SIDEBAR_WIDTH: number = 75;

export const CLASSIC_WIDTH: number = 280;

export const BOOK_MAP_WIDTH: number = 880;

export const BOOK_MAP_HEIGHT: number = 720;

export const MT_ESC_GOOD: string = 'Bueno';

export const MT_ESC_BAD: string = 'Malo';

export const USE_PIXEL_TOOL: boolean = false;

export const SHOW_MS: boolean = false;

export const LB_PM = 'Puntos de Muestreo';

export const ms_icons: Array<T_IconPair> = [
	{
		normal: './img/ms_dots/A_labLabel_white.png',
		hilight: './img/ms_dots/A_labLabel.png',
	},
	{
		normal: './img/ms_dots/ms_dot.png',
		hilight: './img/ms_dots/ms_dot_hilight.png',
	},
	{
		normal: './img/ms_dots/ms_dot_low.png',
		hilight: './img/ms_dots/ms_dot_low_hilight.png',
	},
	{
		normal: './img/ms_dots/ms_dot_small.png',
		hilight: './img/ms_dots/ms_dot_small_hilight.png',
	},
	{
		normal: './img/ms_dots/pin-apagado.png',
		hilight: './img/ms_dots/pin-encendido.png',
	},
	{
		normal: './img/ms_dots/pin-apagado2.png',
		hilight: './img/ms_dots/pin-encendido2.png',
	},
];

export const PATH_ESCALA_MT: string = '/app/data/libro_predios/ESCALA_MT.png';

export const EMPTY_USER: T_User = {
	id: -1,
	user_name: '',
	real_name: '',
	pass: '',
	id_rol: 2,
	role: Unknown,
	email: '',
	session_id: 'FAKE_SESSION_ID',
	dir: '',
	true_dirs: [],
	true_exists: [],
	black_dirs: [],
};

// ROLES QUE PUEDEN USAR LA HERRAMIENTA DE MAPAS DIFERENCIALES:

export const ROLES_DIFF_MAP = [
	// 'Agricultor'
	'AsesorExterno',
	'CoordinadorExterno',
	'MiembroAgrosat',
	'ServiceManager',
	'Coordinador',
];

export const USERS_CR = [
	'octavio.sanchez'
];



// WEBPACK FOOTER //
// ./src/consts.js